  <template >
   <div class="formPosition" v-role="'ped'">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-col md="9">

              <h4 style="text-align:center;"> <span> Solicitações de Mudanças de classe  </span></h4>

<div class="text-center">
  <div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

 
    </div>
      </v-col>
      <v-col md="3">
          <v-text-field
            v-model="searchInDb"
            append-icon="search"
            label="Pesquisa por nome"
            single-line
            hide-details
          ></v-text-field>
      </v-col>
       
    </v-row>

    <v-data-table 
            :headers="headers"
            :items="mudancas"
            :search="searchInDb"
          >

          <template v-slot:item.ord="{ item }">
            <span>{{mudancas.indexOf(item)+1}}</span>
        </template>
         <template v-slot:item.status="{ item }">
            <span v-if="item.estado === 0" style="color:#006699">Pendente</span>
            <span v-if="item.estado === 2" style="color:red">Mudança rejeitada</span>
        </template>
        <template v-slot:item.idanoacademico="{ item }">
            <span>{{ utilitarios.descricaoClasse(item.idanoacademico)}}</span>
        </template>
        <template v-slot:item.idanoacademico_novo="{ item }">
            <span style="font-weight:bold;">{{ utilitarios.descricaoClasse(item.idanoacademico_novo)}}</span>
        </template>


         <template  v-slot:item.action="{ item }">
        <v-menu v-if="item.status === 'Pendente' && role === 'ROLE_ADM'" left origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn fab small dark color="teal" style="color: white" v-on="on">
              <v-icon small>menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item >
               <v-btn small text @click="Confirmar(item)"> <v-icon style="color:green;" small>done</v-icon> Aceitar</v-btn>
            </v-list-item>

            <v-list-item >
               <v-btn small text @click="showRejeitar(item)"><v-icon style="color:red;" small>close</v-icon> Rejeitar</v-btn>
            </v-list-item>
 
          </v-list>
        </v-menu>
      </template>
      <!-- <template v-slot:item.action="{ item }">
        <v-btn v-if="item.status === 'Pendente' && role === 'ROLE_ADM'" small color="green darkeen-5"> <v-icon small color="white"   class="mr-2" @click="Confirmar(item)">done_all</v-icon></v-btn>
        <v-btn style="margin-left:2px;" v-if="item.status === 'Pendente' && role === 'ROLE_ADM'" small color="red darkeen-5"> <v-icon small color="white"   class="mr-2" @click="showRejeitar(item)">close</v-icon></v-btn>
       </template> -->
      </v-data-table>

  </v-container>
<template>
        <v-row justify="center">
          <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">Aceitar da Mudança</span>
                <div style="margin-left:10px;" v-if="this.$store.state.hasMessage" :class="this.$store.state.classMessage" >{{this.$store.state.textMessage}}</div>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>

                     <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        label="Adicionar comentario"
                         persistent-hint
                          v-model="motivo"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <strong>Atenção:Ao confirmar essa operação , não será possivel reverter.</strong>
              </v-card-text>
              <v-card-actions>
                <v-row>
                   <v-col md="10"></v-col>
                   <v-col md="2">
                      <v-progress-circular  v-if="progresso_2"
                    :size="50"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
                   </v-col>
                </v-row>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="dialog  = false">Cancelar</v-btn>
                <v-btn color="green darken-1"  text @click="Continuar_mudanca(1)" >Confirmar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>


          <v-row justify="center">
          <v-dialog v-model="dialogrejeitar" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">Rejeitar Mudança</span>
                <div style="margin-left:10px;" v-if="this.$store.state.hasMessage" :class="this.$store.state.classMessage" >{{this.$store.state.textMessage}}</div>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>

                     <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        label="Adicionar comentario"
                         persistent-hint
                          v-model="motivo"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <strong>Atenção:Ao confirmar essa operação , não será possivel reverter.</strong>
              </v-card-text>
              <v-card-actions>
                <v-row>
                   <v-col md="10"></v-col>
                   <v-col md="2">
                      <v-progress-circular  v-if="progresso_2"
                    :size="50"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
                   </v-col>
                </v-row>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1"  text @click="dialogrejeitar  = false">Cancelar</v-btn>
                <v-btn color="green darken-1" :disabled="!motivo.length" text @click="Continuar_mudanca(2)" >Confirmar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
</template>

</template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
export default {
  data: () => ({

    mudancas: [],
    turmasAll: [],
    classe: 0,
    disabilita: false,
    dialog: false,
    operacao: '',
    utilitarios: utilitarios,
    turma: 0,
    turmasFiltered: [],
    searchInDb:'',
    select1: null,
    estudante_pendente: [],
    pesquisa_parameto: null,
    idinstproveniente: 0,
    estudante_dados: [],
    dialogrejeitar: false,
    disabilita_ano: true,
    funcionarios: [],
    select_anolectivo: null,
    progresso_2: false,
    idMatricula: null,
    estudante: true,
    motivo: '',
    progresso: false,
    Pessoas: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio'],
    Operacoes: [
      { id: 1, descricao: 'Mudança de Classe' },
      { id: 2, descricao: 'Mudança de Turma' },
      { id: 3, descricao: 'Mudança de Curso' }
    ],

    headers: [
      { text: 'Ord ', value: 'ord' },
      { text: 'Nome do Estudante ', value: 'nome' },
      { text: 'Matricula', value: 'idMatricula' },
      { text: 'Classe Actual', value: 'idanoacademico' },
      { text: 'Classe solicitada', value: 'idanoacademico_novo' },
      { text: 'Mensagem enviada pela instituição', value: 'comentario_emissor' },
      { text: 'Mensagem enviada pela Softline', value: 'comentario_admin' },
      { text: 'Status', value: 'status' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    editedItem:
    {
      idMudanca: 0,
      nome: '',
      fkPessoa: 0,
      idMatricula: '',
      bi: '',
      datanascimento: '',
      nomedopai: '',
      nomedamae: '',
      telefone: '',
      descricao_turma: '',
      instituicao: '',
      descricao_curso: '',
      anolectivo: '',
      resultado: '',
      classe: '',
      idAno_Academico: '',
      idCurso: '',
      pkTurma: '',
      idAnoLectivo: 0,
      idTurma: 0,
      pkInscricao_na_turma: 0
    }

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },

    role(){
      return ls.get('role')
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initialize()
  },
  methods: {

    Confirmar (item) {
      this.dialog = true
      this.editedItem = Object.assign({}, item)
    },

    showRejeitar (item) {
      this.dialogrejeitar = true
      this.editedItem = Object.assign({}, item)
    },

    async Continuar_mudanca (operacao) {
      this.progresso_2 = true

      let apidescricao = ( operacao === 1 )?'/MudancaClasseconfirmacaoInsertOrUpdate':'/MudancaClasseconfirmacaoRejeitar'

      let params =
            {
              idMudanca: this.editedItem.idMudanca,
              idmatricula: this.editedItem.idMatricula,
              idturma: this.editedItem.idTurma,
              pkPessoa: this.editedItem.fkPessoa,
              idanolectivo: this.editedItem.idanolectivo,
              pkTurma: this.editedItem.FkTurma_novo,
              idcurso: this.editedItem.idCurso,
              bi: this.editedItem.bi,
              idanoacademico: this.editedItem.idanoacademico_novo,
              resultado: (this.editedItem.resultado === 'Transita') ? 1 : 0,
              descricao_resultado: this.editedItem.resultado,
              fromtransferencia: 0,
              fromMudancaclasse: 1,
              ultimoAnoFeito: this.editedItem.anolectivo,
              autor: ls.get('nomeUsuario'),
              anolectivo: this.editedItem.anolectivo,
              mensagemAdmin: this.motivo
            }

      try {
        // this.isLoading = true
        let msg = await axios
          .post(apidescricao, params)
          .then(res => res.data)
        if(msg.affectedRows >= 0){
           this.text = 'Mudança efectuada com sucesso'
           this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })
        }else{
           this.text = 'Erro ao efectuar a operação'
           this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        }
        this.dialog = false
        this.initialize()

      } catch (error) {
        this.progresso_2 = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }finally{
        this.dialogrejeitar = false
        this.progresso_2 = false
      }
    },

    async Controlo_actividade () {
      let params =
      {
        actividade: 'Mudança de Classe',
        descricao: 'Efectuou a mudança do estudante - : ' + this.editedItem.nome + '-Matricula: ' + this.editedItem.nome + 'nova turma : ' + this.editedItem.FkTurma_novo
      }

      try {
        let msg = await axios
          .post('/controlo-actividades', params)
          .then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initialize (searchInDb) {
      try {
        this.isLoading = true

        this.mudancas = await axios
          .get('/ListarMudancas')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async ActualizaMudanca_Classe_Curso () {
      let params =
          {
            nome: null,
            idMudanca: this.editedItem.idMudanca,
            bi: null,
            resultado: null,
            idAno_Academico: null,
            fkTurma: null,
            idCurso: null,
            idMatricula: null,
            operacao: null,
            fkTurma_novo: null,
            idanoacademico_novo: null,
            descricao_operacao: null,
            idCursoNovo: null,
            AutorAdmin: ls.get('idPessoa'),
            idanolectivo: null,
            fkPessoa: null,
            idTurma: null,
            mensagem_instituicao: null,
            mensagem_admin: this.motivo,
            pkInscricao_na_turma: this.editedItem.pkInscricao_na_turma
          }

      try {
        let msg = await axios
          .post('/ActualizaMudanca_Classe_Curso', params)
          .then(res => res.data)
        this.motivo = ''
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount
      const ls = require('local-storage')
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }

  }

}

</script>
